export const kebabize = (str: string): string => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs: boolean) => (ofs ? '-' : '') + $.toLowerCase());
